import { defineStore } from 'pinia'

export interface AppState {
    loading: boolean
    publicPath: boolean
}

export interface AppActions {
    loadingWhile(action: () => Promise<unknown>): Promise<void>
}

export const useAppStore = defineStore<'app', AppState, {}, AppActions>('app', {
    state: () => ({
        loading: false,
        publicPath: process.env.VUE_APP_PUBLIC_PATH
    }),
    actions: {
        async loadingWhile(action: () => Promise<unknown>) {
            this.loading = true
            try {
                await action()
            } finally {
                this.loading = false
            }
        }
    }
})